import { ChevronRightIcon } from "@heroicons/react/solid";
import { useState } from "react";
import { NavItemInterface, SubNavItemInterface } from "..";
import { usePermission } from "../../../../hooks/usePermission";
import AppNavLink from "../../../Router/AppNavLink";

import styles from "./NavItem.module.css";

export interface ClickConfig {}
export interface NavItemProps {
  item: NavItemInterface;
  isFullNavHidden?: boolean;
  onItemClick?: () => void;
}
export default function NavItem({
  item,
  isFullNavHidden,
  onItemClick,
}: NavItemProps) {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const { hasPermission } = usePermission();
  return (
    <div>
      <AppNavLink
        to={item.path}
        baseClassName={`flex justify-center items-center p-2 text-sm hover:bg-neutralColor-lightest ${styles["hover-trigger"]}`}
        activeClassName={`bg-neutralColor-lightest text-primaryColor-normal`}
        inactiveClassName="text-neutralColor-normal hover:text-primaryColor-normal"
        clicked={() => {
          setShowSubMenu((prevState) => !prevState);
          if (item.subMenu && showSubMenu && onItemClick) {
            onItemClick();
          }
        }}
      >
        <item.icon
          className={`h-6 w-6 ${!isFullNavHidden && "mr-3"}`}
          aria-hidden="true"
        />
        <span
          className={`w-80 overflow-hidden ${
            isFullNavHidden ? "hidden" : "block flex justify-between"
          }`}
        >
          {item.name}
          {item.subMenu && (
            <ChevronRightIcon
              className={`h-5 w-5 transition duration-400 ease-in-out ${
                showSubMenu ? "transform rotate-90" : "transform rotate-0"
              }`}
            />
          )}
        </span>
        {isFullNavHidden && (
          <div className={`${styles["item-bubble"]} ${styles["hover-target"]}`}>
            <span
              className={`block ${
                item.subMenu ? "border-b" : ""
              } font-bold pb-1`}
            >
              {item.name}
            </span>
            {item.subMenu &&
              item.subMenu.map((sub: SubNavItemInterface) => {
                if (hasPermission(sub.permissions)) {
                  return (
                    <AppNavLink
                      key={sub.name}
                      to={item.path + sub.path}
                      activeClassName="text-primaryColor-light"
                      baseClassName="py-1.5 text-white hover:text-primaryColor-light flex items-center text-sm rounded-md"
                    >
                      {sub.name}
                    </AppNavLink>
                  );
                }
              })}
          </div>
        )}
      </AppNavLink>
      <div
        className={`flex flex-col transition-height duration-500 ease-in-out ${
          isFullNavHidden ? "hidden" : `block`
        }`}
      >
        {item.subMenu &&
          showSubMenu &&
          item.subMenu.map((sub: SubNavItemInterface) => {
            if (hasPermission(sub.permissions)) {
              return (
                <AppNavLink
                  key={sub.name}
                  to={item.path + sub.path}
                  activeClassName="text-primaryColor"
                  inactiveClassName="text-neutralColor"
                  clicked={onItemClick}
                  baseClassName="px-4 py-2 ml-8 hover:text-primaryColor flex items-center text-sm"
                >
                  {sub.name}
                </AppNavLink>
              );
            }
          })}
      </div>
    </div>
  );
}
